import { PageComponentProps, AccordionComponentContent } from '../types/page_component_types'

export function extractFaqItems(
  content?: PageComponentProps[]
): { heading?: string; richText?: string }[] | undefined {
  if (!content) return undefined

  const accordions = content.filter(
    (c): c is AccordionComponentContent => c.type === 'accordion'
  )

  const items = accordions.flatMap(a => a.accordionItems || [])

  return items.length > 0 ? items : undefined
}
